import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cab32e5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "price-line"
}
const _hoisted_2 = { class: "price-line-amount" }
const _hoisted_3 = { class: "price-line font-bold" }
const _hoisted_4 = { class: "price-line-amount" }
const _hoisted_5 = {
  key: 2,
  class: "price-line"
}
const _hoisted_6 = { class: "price-line-amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegularItemNonMemberPrice = _resolveComponent("RegularItemNonMemberPrice")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.price.discounts?.length || _ctx.quantity > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.labels.lineItemPricePerItem) + " ", 1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.price.listPrice?.amount), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.price.discounts, (discount) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getDiscountComponentByType(discount.type)), {
        key: discount.type,
        discount: discount
      }, null, 8, ["discount"]))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.labels.lineItemPriceTotal) + " ", 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.hasMyBoliaBoostDiscount ? _ctx.price.memberSalesPriceTotal?.amount : _ctx.price.salesPriceTotal?.amount), 1)
    ]),
    (_ctx.hasMyBoliaBoostDiscount)
      ? (_openBlock(), _createBlock(_component_RegularItemNonMemberPrice, {
          key: 1,
          price: _ctx.price
        }, null, 8, ["price"]))
      : _createCommentVNode("", true),
    (_ctx.price.ecoTaxTotal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$dictionary.get('b2c/productDetailItem/ecoTax')) + " ", 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.price.ecoTaxTotal.amount), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}